import _extends from "@babel/runtime/helpers/extends";
import { Box, Text, Tooltip } from '@wix/design-system';
import React from 'react';
import { useCycleName } from '../../hooks/useCycleName';
export const CycleSelectorItemName = _ref => {
  let {
    dataHook,
    tooltipDataHook,
    textProps,
    cycle,
    showInMonths,
    tooltipContent,
    onShowTooltip,
    ...boxProps
  } = _ref;
  const cycleName = useCycleName({
    cycle,
    showInMonths
  });
  const handleShowTooltip = () => {
    onShowTooltip == null || onShowTooltip(tooltipContent);
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    dataHook: tooltipDataHook,
    disabled: !tooltipContent,
    content: tooltipContent,
    placement: "bottom",
    onShow: handleShowTooltip
  }, /*#__PURE__*/React.createElement(Box, _extends({
    dataHook: dataHook
  }, boxProps), /*#__PURE__*/React.createElement(Text, textProps, cycleName)));
};
//# sourceMappingURL=CycleSelectorItemName.js.map